/*******************************************************************
* PAGE        : AmcWarrantyManagementList
* REMARKS     :
* CREATED ON  : 19-05-2026
* AUTHOR      : Gurjar.Sonal
* MODIFY      : 
* MODIFY ON   : 
********************************************************************/

import React, { useEffect, useState } from 'react';
import SnackbarsComponent from '../../components/SnackbarsComponent/SnackbarsComponent';
import ListComponent from '../../components/ListComponent/ListComponent';
import CommonModal from '../../components/ModalComponent/CommonModal';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TabComponent from '../../components/TabComponent/TabComponent';
import AmcWarrantyManagamentDetailsPage from './AmcWarrantyManagamentDetailsPage';
import CustomTabComponent from '../../components/CustomTabComponent/CustomTabComponent';
import TitleComponent from '../../components/TitleComponent/TitleComponent';
import { CMExpressAPIAMCDetailsGet } from '../../services/apiController';


const OverdueAMCWarrantyList = [

    {
        id: 1,
        customerName: "Rayn",
        amcNo: "AMC-2026-101",
        contractNo: "AMC-2024-00187",
        productName: "Bulk Milk Cooler 5000L",

        customerDetails: {
            name: "Rajesh Dairy Farms Pvt. Ltd.",
            phone: "+91 98221 34567",
            email: "rajesh@rdairy.co.in",
            city: "Pune, Maharashtra",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Bulk Milk Cooler 5000L",
            productCode: "BMC-5000-PRO",
            serialNo: "SN-BMC-2022-04412",
            fromDate: "15 Jan 2024",
            toDate: "14 Jan 2025",
            location: "MIDC Phase-II, Pune",
            total: 12,
            done: 7,
            freeExtra: 2,
            interval: 30,
            coverage: "Parts + Labour",
            sla: "24 Hrs",
            value: "₹ 48,500",
            renewIn: 42,
        },
    },

    {
        id: 2,
        customerName: "Mary Castillo",
        amcNo: "AMC-2026-102",
        contractNo: "AMC-2024-00188",
        productName: "Milk Chilling Unit",

        customerDetails: {
            name: "Fresh Dairy Pvt. Ltd.",
            phone: "+91 98765 43210",
            email: "fresh@dairy.com",
            city: "Mumbai, Maharashtra",
        },

        amcDetails: {
            type: "Non-Comprehensive AMC",
            status: "Expiring Soon",
            product: "Milk Chilling Unit",
            productCode: "MCU-2200",
            serialNo: "SN-MCU-2023-1122",
            fromDate: "10 Feb 2024",
            toDate: "09 Feb 2025",
            location: "Andheri Industrial Area, Mumbai",
            total: 10,
            done: 5,
            freeExtra: 1,
            interval: 45,
            coverage: "Labour Only",
            sla: "12 Hrs",
            value: "₹ 38,000",
            renewIn: 15,
        },
    },

    {
        id: 3,
        customerName: "Christina Rodriguez",
        amcNo: "AMC-2026-103",
        contractNo: "AMC-2024-00189",
        productName: "Industrial Freezer",
        customerDetails: {
            name: "CoolTech Industries",
            phone: "+91 97654 33221",
            email: "support@cooltech.in",
            city: "Nagpur, Maharashtra",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Industrial Freezer",
            productCode: "IF-3200",
            serialNo: "SN-IF-2023-7788",
            fromDate: "01 Mar 2024",
            toDate: "28 Feb 2025",
            location: "Nagpur MIDC",
            total: 8,
            done: 3,
            freeExtra: 2,
            interval: 60,
            coverage: "Full Coverage",
            sla: "8 Hrs",
            value: "₹ 62,000",
            renewIn: 65,
        },
    },

    {
        id: 4,
        customerName: "Kelly Williams",
        amcNo: "AMC-2026-104",
        contractNo: "AMC-2024-00190",
        productName: "Cold Storage Unit",
        customerDetails: {
            name: "Sunrise Foods",
            phone: "+91 98989 45454",
            email: "contact@sunrisefoods.com",
            city: "Nashik, Maharashtra",
        },

        amcDetails: {
            type: "Preventive AMC",
            status: "Expired",
            product: "Cold Storage Unit",
            productCode: "CSU-9000",
            serialNo: "SN-CSU-9988",
            fromDate: "20 Jan 2023",
            toDate: "19 Jan 2024",
            location: "Nashik Industrial Area",
            total: 15,
            done: 15,
            freeExtra: 0,
            interval: 20,
            coverage: "Service Only",
            sla: "48 Hrs",
            value: "₹ 28,000",
            renewIn: 0,
        },
    },

    {
        id: 5,
        customerName: "Aaron Brooks",
        amcNo: "AMC-2026-105",
        contractNo: "AMC-2024-00191",
        productName: "Milk Pasteurizer",

        customerDetails: {
            name: "Metro Dairy",
            phone: "+91 91234 12345",
            email: "info@metrodairy.in",
            city: "Delhi",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Milk Pasteurizer",
            productCode: "MP-4500",
            serialNo: "SN-MP-1122",
            fromDate: "11 Apr 2024",
            toDate: "10 Apr 2025",
            location: "Delhi NCR",
            total: 6,
            done: 2,
            freeExtra: 1,
            interval: 90,
            coverage: "Parts + Service",
            sla: "24 Hrs",
            value: "₹ 55,000",
            renewIn: 88,
        },
    },

    {
        id: 6,
        customerName: "James White",
        amcNo: "AMC-2026-106",
        contractNo: "AMC-2024-00192",
        productName: "Cooling Compressor",

        customerDetails: {
            name: "Prime Cooling Systems",
            phone: "+91 99887 77665",
            email: "sales@primecooling.com",
            city: "Ahmedabad, Gujarat",
        },

        amcDetails: {
            type: "Standard AMC",
            status: "Active",
            product: "Cooling Compressor",
            productCode: "CC-500",
            serialNo: "SN-CC-8899",
            fromDate: "05 May 2024",
            toDate: "04 May 2025",
            location: "Ahmedabad GIDC",
            total: 9,
            done: 4,
            freeExtra: 1,
            interval: 35,
            coverage: "Labour + Inspection",
            sla: "18 Hrs",
            value: "₹ 42,000",
            renewIn: 72,
        },
    },

    {
        id: 7,
        customerName: "Robert Cantrell",
        amcNo: "AMC-2026-107",
        contractNo: "AMC-2024-00193",
        productName: "Cooling Tank",
        customerDetails: {
            name: "Golden Dairy",
            phone: "+91 90000 56789",
            email: "golden@gdairy.com",
            city: "Hyderabad",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Expiring Soon",
            product: "Cooling Tank",
            productCode: "CT-7000",
            serialNo: "SN-CT-2022-5555",
            fromDate: "12 Jun 2024",
            toDate: "11 Jun 2025",
            location: "Hyderabad Industrial Zone",
            total: 11,
            done: 8,
            freeExtra: 2,
            interval: 25,
            coverage: "Full Service",
            sla: "10 Hrs",
            value: "₹ 70,000",
            renewIn: 9,
        },
    },

    {
        id: 8,
        customerName: "Sonal",
        amcNo: "AMC-2026-108",
        contractNo: "AMC-2024-00194",
        productName: "Deep Freezer",
        customerDetails: {
            name: "Fresh Milk Co.",
            phone: "+91 98888 11111",
            email: "hello@freshmilk.com",
            city: "Pune",
        },

        amcDetails: {
            type: "Preventive AMC",
            status: "Active",
            product: "Deep Freezer",
            productCode: "DF-550",
            serialNo: "SN-DF-3344",
            fromDate: "25 Jul 2024",
            toDate: "24 Jul 2025",
            location: "Pimpri, Pune",
            total: 7,
            done: 3,
            freeExtra: 1,
            interval: 40,
            coverage: "Inspection + Labour",
            sla: "24 Hrs",
            value: "₹ 31,000",
            renewIn: 95,
        },
    },

    {
        id: 9,
        customerName: "Paras",
        amcNo: "AMC-2026-109",
        contractNo: "AMC-2024-00195",
        productName: "Industrial Cooler",

        customerDetails: {
            name: "Urban Foods",
            phone: "+91 97777 55555",
            email: "urban@foods.com",
            city: "Bangalore",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Industrial Cooler",
            productCode: "IC-9900",
            serialNo: "SN-IC-6677",
            fromDate: "08 Aug 2024",
            toDate: "07 Aug 2025",
            location: "Electronic City",
            total: 14,
            done: 6,
            freeExtra: 3,
            interval: 15,
            coverage: "Complete Coverage",
            sla: "6 Hrs",
            value: "₹ 88,000",
            renewIn: 112,
        },
    },

    {
        id: 10,
        customerName: "Akshay",
        amcNo: "AMC-2026-110",
        contractNo: "AMC-2024-00196",
        productName: "Refrigeration Unit",

        customerDetails: {
            name: "Smart Cooling Pvt. Ltd.",
            phone: "+91 96666 44444",
            email: "support@smartcooling.com",
            city: "Chennai",
        },

        amcDetails: {
            type: "Non-Comprehensive AMC",
            status: "Expired",
            product: "Refrigeration Unit",
            productCode: "RU-1100",
            serialNo: "SN-RU-9981",
            fromDate: "01 Sep 2023",
            toDate: "31 Aug 2024",
            location: "Chennai SIPCOT",
            total: 5,
            done: 5,
            freeExtra: 0,
            interval: 60,
            coverage: "Service Only",
            sla: "36 Hrs",
            value: "₹ 22,000",
            renewIn: 0,
        },
    },

]
const UpcomingAMCWarrantyList = [
    {
        id: 1,
        customerName: "User 1",
        amcNo: "AMC-2026-101",
        contractNo: "AMC-2024-00187",
        productName: "Refrigeration Unit",

        customerDetails: {
            name: "Rajesh Dairy Farms Pvt. Ltd.",
            phone: "+91 98221 34567",
            email: "rajesh@rdairy.co.in",
            city: "Pune, Maharashtra",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Bulk Milk Cooler 5000L",
            productCode: "BMC-5000-PRO",
            serialNo: "SN-BMC-2022-04412",
            fromDate: "15 Jan 2024",
            toDate: "14 Jan 2025",
            location: "MIDC Phase-II, Pune",
            total: 12,
            done: 7,
            freeExtra: 2,
            interval: 30,
            coverage: "Parts + Labour",
            sla: "24 Hrs",
            value: "₹ 48,500",
            renewIn: 42,
        },
    },
    {
        id: 2,
        customerName: "User 2",
        amcNo: "AMC-2026-101",
        contractNo: "AMC-2024-00187",
        productName: "Bulk Milk Cooler 5000L",

        customerDetails: {
            name: "Priya Patel",
            phone: "+91 98221 34567",
            email: "rajesh@rdairy.co.in",
            city: "Pune, Maharashtra",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Bulk Milk Cooler 5000L",
            productCode: "BMC-5000-PRO",
            serialNo: "SN-BMC-2022-04412",
            fromDate: "15 Jan 2024",
            toDate: "14 Jan 2025",
            location: "MIDC Phase-II, Pune",
            total: 12,
            done: 7,
            freeExtra: 2,
            interval: 30,
            coverage: "Parts + Labour",
            sla: "24 Hrs",
            value: "₹ 48,500",
            renewIn: 42,
        },
    },
    {
        id: 3,
        customerName: "User 3",
        amcNo: "AMC-2026-101",
        contractNo: "AMC-2024-00187",
        productName: "KeyBorad Acc",

        customerDetails: {
            name: "Rahul Sharma",
            phone: "+91 98221 34567",
            email: "rajesh@rdairy.co.in",
            city: "Pune, Maharashtra",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Bulk Milk Cooler 5000L",
            productCode: "BMC-5000-PRO",
            serialNo: "SN-BMC-2022-04412",
            fromDate: "15 Jan 2024",
            toDate: "14 Jan 2025",
            location: "MIDC Phase-II, Pune",
            total: 12,
            done: 7,
            freeExtra: 2,
            interval: 30,
            coverage: "Parts + Labour",
            sla: "24 Hrs",
            value: "₹ 48,500",
            renewIn: 42,
        },
    },
]
const ActiveAMCWarrantyList = [
    {
        id: 1,
        customerName: "Rahul Sharma",
        amcNo: "AMC-2026-101",
        contractNo: "AMC-2024-00187",
        productName: "Printer Maintenance",

        customerDetails: {
            name: "ABC Technologies Pvt Ltd",
            phone: "+91 98221 34567",
            email: "rahul@abctech.com",
            city: "Pune, Maharashtra",
        },

        amcDetails: {
            type: "Non-Comprehensive AMC",
            status: "Active",
            product: "Printer Maintenance",
            productCode: "BMC-5000-PRO",
            serialNo: "SN-BMC-2022-04412",
            fromDate: "15 Jan 2024",
            toDate: "14 Jan 2025",
            location: "MIDC Phase-II, Pune",
            total: 12,
            done: 7,
            freeExtra: 2,
            interval: 30,
            coverage: "Parts + Labour",
            sla: "24 Hrs",
            value: "₹ 48,500",
            renewIn: 42,
        },
    },
    {
        id: 2,
        customerName: "skyline Enterprises",
        amcNo: "AMC-2026-152",
        contractNo: "AMC-2024-00187",
        productName: "CCTV System",

        customerDetails: {
            name: "Priya Patel",
            phone: "+91 98221 34567",
            email: "amit@skyline.co",
            city: "Pune, Maharashtra",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "CCTV System",
            productCode: "BMC-5000-PRO",
            serialNo: "SN-BMC-2022-04412",
            fromDate: "15 Jan 2024",
            toDate: "14 Jan 2025",
            location: "Nagpur",
            total: 12,
            done: 7,
            freeExtra: 2,
            interval: 30,
            coverage: "Parts + Labour",
            sla: "24 Hrs",
            value: "₹ 48,500",
            renewIn: 42,
        },
    },
    {
        id: 3,
        customerName: "User 3",
        amcNo: "AMC-2026-121",
        contractNo: "AMC-2024-00187",
        productName: "Networking Devices",

        customerDetails: {
            name: "NextGen Solutions",
            phone: "+91 9765432101",
            email: "priya@nextgen.com",
            city: "Nashik",
        },

        amcDetails: {
            type: "Comprehensive AMC",
            status: "Active",
            product: "Networking Devices",
            productCode: "BMC-5000-PRO",
            serialNo: "SN-BMC-2022-04412",
            fromDate: "15 Jan 2024",
            toDate: "14 Jan 2025",
            location: "Nashik",
            total: 12,
            done: 7,
            freeExtra: 2,
            interval: 30,
            coverage: "Parts + Labour",
            sla: "24 Hrs",
            value: "₹ 48,500",
            renewIn: 42,
        },
    },
]
// #region Component
const AmcWarrantyManagementList = () => {

    // #region States

    const userIdentification = useSelector(s => s.reduxMaster.userMasterIdentification);

    const location = useLocation(); // To track the current location/path of the page
    const SidebarMENU = useSelector(s => s.reduxMaster.masterArray?.SidebarMENU);
    const menuName = SidebarMENU.find(m => m.PageUrl === location.pathname);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    const next15Days = new Date(today);
    next15Days.setDate(next15Days.getDate() + 15);

    const [loading, setLoading] = useState(false);  // State to manage loading status
    const [allData, setAllData] = useState([]);  // State to store all the data
    const [listData, setListData] = useState([]);  // State to store the list of data

    const [activeTab, setActiveTab] = useState("1");

    const [initialStates, setInitialStates] = useState({ PopupTitle: "", PopupActionText: "", PopupAction: "", EditID: "", PopupOpen: "" }); // Initial states for the modal and popup data

    // Close the snackbar after a specified time
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' }); // Snackbar state for showing messages like success or error
    const handleCloseSnackbar = (status) => { setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' }); };

    // Header buttons configuration (like Add User, Sync)  menuName?.IsAllowAdd ? 101 : null
    const headerButtons = [
        { id: 103, name: "Send Reminder", color: "primary", size: "small", type: 'button' }
    ];

    // Data for the grid columns configuration
    const gridColumnsData = [
        { label: "Customer Name", name: "AccountName", actionType: 2, minWidth: "250px", },
        { label: "Product Name", name: "ItemName", actionType: 2, minWidth: "250px", },
        { label: "Item Code", name: "ItemCode", actionType: 2, minWidth: "80px", },
        {
            label: "Actions", name: "actions", minWidth: "50px", textAlign: 'center', actionType: 1,
            actionButtons: [
                { id: 101, name: 'View', color: "primary", size: "18px", type: 'icon' },
                ...(activeTab === "0" ? [{ id: 5, name: 'CheckBox', color: "primary", size: "18px", type: 'action', checkBoxKey: 'selected' }] : []),
            ]
        }
    ];
    // #endregion

    //#region API Call
    useEffect(() => {
        wsCMExpressAPIAMCDetailsGet();
    }, []);

    const wsCMExpressAPIAMCDetailsGet = async () => {
        setLoading(true);

        const payloadBody = {
            isMobileUser: 'false',
            strUserIdentification: userIdentification
        };

        try {
            const response = await CMExpressAPIAMCDetailsGet(payloadBody);
            if (response.status) {
                const modifiedData = response.data.map(item => (item.ToPeriodDate === "2023-03-25T00:00:00" ? { ...item, id: item.AMCDetailsId, ToPeriodDate: "2026-06-26T00:00:00", WarrantyStatus: "In AMC" } : { ...item, id: item.AMCDetailsId }));

                setAllData(modifiedData);

                // Default tab = Overdue
                const overdueData = modifiedData.filter(item => {
                    const toDate = new Date(item.ToPeriodDate);
                    return toDate < today && toDate >= oneYearAgo;;
                });

                setListData(overdueData);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    //#endregion

    //#region handler function
    // Function to handle action button click (Add, View, Edit, Delete, Sync)
    const handleActionBtnClick = ((btnId, eleId, ele) => {
        if (btnId == 101) { // View AMC Managament
            // const data = activeTab == "2" ? UpcomingAMCWarrantyList[eleId] : OverdueAMCWarrantyList[eleId];
            // setAllDetails(data)
            setInitialStates({ ...initialStates, Action: 3, PopupTitle: 'AMC / Warranty Managament Details', PopupActionText: 'Save', PopupAction: 'View', EditID: 0, DetailedData: ele, PopupOpen: true });
        } else if (btnId == 203) {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: 'Send Renewal Successfully.', snackbarSeverity: 'success' });
            window.location.reload();
        }
    });

    // Function to close the modal
    const handleCloseModal = () => setInitialStates({ ...initialStates, PopupOpen: false });

    const TabData = [
        { id: "1", label: 'Overdue AMC' },
        { id: "2", label: 'Upcoming AMC' },
        { id: "3", label: 'Active AMC' },
    ];

    // Handle Tab Change (When a tab is clicked)
    const handleTabChange = (id) => {
        setActiveTab(id);
        let filteredData = [];

        switch (id) {
            case "1": // Overdue AMC
                filteredData = allData.filter(item => {
                    const toDate = new Date(item.ToPeriodDate);

                    return toDate < today && toDate >= oneYearAgo;
                });
                break;

            case "2": // Upcoming AMC
                filteredData = allData.filter(item => {
                    const toDate = new Date(item.ToPeriodDate);

                    return toDate >= today && toDate <= next15Days;
                });
                break;

            case "3": // Active AMC
                filteredData = allData.filter(item => {
                    const fromDate = new Date(item.FromPeriodDate);
                    const toDate = new Date(item.ToPeriodDate);

                    return fromDate <= today && toDate >= today;
                });
                break;

            default: filteredData = [];
        }

        setListData(filteredData);
    };

    const handleDelete = () => {
        setInitialStates({ ...initialStates, PopupOpen: false });
        setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: 'Complaint close successfully', snackbarSeverity: 'success' });
        // alert("Close: " + initialStates.EditID); // Handle close action (can be customized)
    };

    // #endregion

    return (
        <React.Fragment>
            {/* Snackbar notification for success/failure messages */}
            <SnackbarsComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

            <div className='page-title-with-tab'>
                <TitleComponent Title={"AMC / Warranty Management"} />
                <CustomTabComponent TabData={TabData} activeTabId={activeTab} onClick={handleTabChange} />
            </div>

            {/* ListComponent for displaying AMC / Warranty Managament */}
            <ListComponent
                gridColumns={gridColumnsData}
                gridData={listData}
                isLoading={loading}
                headerButtons={headerButtons}
                handleActionBtnClick={handleActionBtnClick}
            />

            {/* Modal for Add/Edit/View/Delete AMC / Warranty Managament */}
            {initialStates.PopupOpen &&
                <CommonModal
                    maxWidth={'md'}
                    Title={initialStates.PopupTitle}
                    ActionText={initialStates.PopupActionText}
                    IsDeletePopup={initialStates.Action == 1 ? true : false}
                    IsLoading={initialStates.loading}
                    onClose={handleCloseModal.bind(this)}
                    onSave={handleDelete.bind(this)}
                    disableOuterClick={true}
                    IsScroll
                >
                    <AmcWarrantyManagamentDetailsPage DetailedData={initialStates.DetailedData} setSnackbarStates={setSnackbarStates} handleCloseModal={handleCloseModal} />
                </CommonModal>}

        </React.Fragment>
    );
};
// #endregion

export default AmcWarrantyManagementList;